export const TOTAL_PNL = {
  prefix: "$",
  value: 229872.41432,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
